import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";
import RecallCertificationStatusView from "../../Models/Recall/RecallCertificationStatusView";

export default () =>
  axiosApi.get<RecallCertificationStatusView[]>(
    `${BackendServices.RECALL_SERVICE.RECALL}/CertificationStatuses`
  );
